export default __webpack_public_path__ + "static/media/visby-cf-demi-bold.ee1450e4.ttf";